import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"

import useUserNavigationUtils from "@hooks/useUserNavigationUtils"

import { NavigationItem } from "@molecules"

export default function WhatsNew() {
    const { openChangelog } = useUserNavigationUtils()

    return (
        <NavigationItem
            onClick={() => openChangelog()}
            variant="secondary"
            label="What's New"
            icon={icon({ name: "bullhorn", style: "regular", family: "sharp" })}
            iconActive={icon({ name: "bullhorn", style: "solid", family: "sharp" })}
        />
    )
}
